import { log } from '../logs';

export const watchContainer = (element: Element, callback: (isIntersecting: boolean) => void, options: IntersectionObserverInit) => {
  const intersectionObserver = new IntersectionObserver((entries) => {
    const [{
      isIntersecting
    }] = entries;
    callback(isIntersecting);
  }, options);

  intersectionObserver.observe(element);

  return intersectionObserver;
};

export const createPlayerDom = (rootId: string, enabledPersistentPlayer: boolean): string => {
  const rootTag = document.querySelector(`#${rootId}`);

  // this should live in the plugin, for refactoring..
  if (enabledPersistentPlayer) {
    const persistentAction = document.createElement('div');
    persistentAction.setAttribute('class', 'pixels-persistent-action-root');
    persistentAction.innerHTML = `<span class="close-persistent-player"><svg xmlns="http://www.w3.org/2000/svg"
     viewBox="0 0 384 512">
    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
</svg></span>`;
    rootTag.appendChild(persistentAction);
  }

  const videoTag = document.createElement('video');
  videoTag.setAttribute('id', `pixelsVideo-${Date.now()}`);
  videoTag.setAttribute('class', 'video-js vjs-16-9 pixels-js');
  videoTag.setAttribute('muted', 'muted');
  videoTag.setAttribute('controls', 'controls');
  videoTag.setAttribute('preload', 'auto');
  videoTag.setAttribute('width', '100%');
  videoTag.setAttribute('playsinline', '');
  rootTag.appendChild(videoTag);

  log('pixels', 'created and attached player to', rootId);

  return videoTag.id;
};

const watcher = (intersectionCallback: () => void, timeoutMs = 2000) => {
  let id: number;

  return (isIntersecting: boolean) => {
    if (isIntersecting) {
      // IAB viewable, 50% visible on viewport for at least X seconds
      id = window.setTimeout(intersectionCallback, timeoutMs);
    } else {
      clearTimeout(id);
    }
  };
};

export const elementViewableManager = (el: Element, timeoutMs: number) => {
  let intersectionObserver: IntersectionObserver;

  return {
    watchImpression: (impressionCallback: () => void) => {
      if (intersectionObserver) return;

      intersectionObserver = watchContainer(el, watcher(impressionCallback, timeoutMs), { threshold: 0.5 });
    },
    dispose: () => {
      if (!intersectionObserver) return;

      intersectionObserver.unobserve(el);
      intersectionObserver = null;
    }
  };
};